import React , { useState } from "react"
import { Button, Alert, Typography, TextField } from '@mui/material'
import styles from './PasswordRecovery.module.scss'
import axios from "axios"


export default function PasswordRecovery() {
    const [ email, setEmail ] = useState('')
    const [ emailSendMsg , setEmailSendMsg ] = useState(false)
    const [ isError , setIsError ] = useState(false)

    const sendEmailRecovery = (event) => {
        event.preventDefault()
        // fetch('/api/sendEmailPasswordRecoverylLink', {
        //     method: 'post',
        //     headers: {'Content-Type': 'application/json'},
        //     body: JSON.stringify({email})
        // })
        axios({
            method: 'post',
            url: '/api/sendEmailPasswordRecoverylLink',
            data: {email}
        }).then(res => res.data).then(result => {
            setEmailSendMsg(true)
        }).catch(e => {
            setIsError(true)
        })
    }

    const emailCensor = () => {
        const userEmail = email.split('@')
        if(userEmail[0].length >= 4 ){
            const emailToShow = userEmail[0].substring(0,userEmail[0].length-5)
            return `${emailToShow}****@${userEmail[1]}`
        }
        else{
            return `${'*'.repeat(userEmail[0].length)}@${userEmail[1]}`
        }
    }

    const resetPasswordContent = () => (
        <>
            <Typography variant="h3" className={styles['h3']}>Please enter your registered email address. An email notification with a password reset code will then be sent to you.</Typography>
            <form onSubmit={sendEmailRecovery} className={styles['content']} >
                <TextField
                    required
                    type="email"
                    value={email}
                    onChange={e => {setEmail(e.target.value)}}
                    placeholder="Email"
                    variant="outlined"
                    className={styles['input']}
                />
                <Button className={styles['button']} size="large" variant="contained" color="primary" type="submit" value="Submit">Send Email</Button>
            </form>
            {isError && <Alert severity="error">There was a problem communicating with Fundamental Edge servers.{"\n"}Try again later</Alert>}
        </>
    )

    const emailSent = () => (
        <>
            <Typography variant="h2">Email Sent</Typography>
            <Typography variant="h3" className={styles['input']}>An email has been sent to your rescue email address, {emailCensor()}. Follow the directions in the email to reset password.</Typography>
        </>
    )

    return (
        <div className={styles['content']}>
            {emailSendMsg ? emailSent() : resetPasswordContent()} 
        </div>   
    )
}